import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class BeniBreakdownPeriodSegmentRanking extends Model {
  [Type] = 'benchmark-insight/breakdown-period-segment-ranking' as const;

  @attr('number') declare adr: number | null;
  @attr('number') declare occupancy: number | null;
  @attr('number') declare occupancyMix: number | null;
  @attr('number') declare revpar: number | null;
  @attr('number') declare size: number | null;

  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedAdr() {
    return this.intl.t('benchmark_insight.ranking_fraction', {
      ranking: this.adr ?? this.intl.t('general.missing'),
      maxRanking: this.formattedSize,
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancy() {
    return this.intl.t('benchmark_insight.ranking_fraction', {
      ranking: this.occupancy ?? this.intl.t('general.missing'),
      maxRanking: this.formattedSize,
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancyMix() {
    return this.intl.t('benchmark_insight.ranking_fraction', {
      ranking: this.occupancyMix ?? this.intl.t('general.missing'),
      maxRanking: this.formattedSize,
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedRevpar() {
    return this.intl.t('benchmark_insight.ranking_fraction', {
      ranking: this.revpar ?? this.intl.t('general.missing'),
      maxRanking: this.formattedSize,
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedSize() {
    return this.size ?? this.intl.t('general.missing');
  }
}
